module.exports = __webpack_public_path__ + "static/media/FamilyConnections2007.c0a93c62.jpg";